import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Stack,
  Typography,
  TextField,
  IconButton,
  Card,
  CardContent,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import "./landingPage.css";
import { routePath } from "../../constants/routePath";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import BannerImage1 from "../../assets/banner_image.png";
import offerCarouselImage from "../../assets/swiperImage.png";
import { useEffect, useRef, useState } from "react";
import { cityName, cityNameCll } from "./landingPageApi";
import { useDispatch, useSelector } from "react-redux";
import { setDetail, setNavBarInputFields } from "../../app/store/reducer";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import icon1 from "../../assets/home/consult.jpg";
import icon2 from "../../assets/home/franchise.jpg";
import icon3 from "../../assets/home/furniture.jpg";
import icon4 from "../../assets/home/jobs.jpg";
import icon5 from "../../assets/home/training.png";
import icon6 from "../../assets/home/white.jpg";
import icon7 from "../../assets/home/wholesa.jpg";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import categoryCard1 from "../../assets/categoryCard1.png";
import categoryCard2 from "../../assets/categoryCard2.png";
import categoryCard3 from "../../assets/categoryCard3.png";
import categoryCard4 from "../../assets/categoryCard4.png";
import categoryCard5 from "../../assets/categoryCard5.png";
import categoryCard6 from "../../assets/categoryCard6.png";
import categoryCard7 from "../../assets/categoryCard7.png";
import categoryCard8 from "../../assets/categoryCard8.png";
import categoryCard9 from "../../assets/categoryCard9.png";
import categoryCard10 from "../../assets/categoryCard10.png";
import categoryCard11 from "../../assets/categoryCard11.png";
import categoryCard12 from "../../assets/categoryCard12.png";
import salonImage from "../../assets/salonImage.png";
import locationIcon from "../../assets/locationIconHome.png";
import StarIcon from "@mui/icons-material/Star";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import Footer from "../../common/Footer";
import ProfilePage from "./FavouritePage";
import FavouritePage from "./FavouritePage";
import { getAllServices } from "../services/servicesListApi";
import { useTheme } from "@emotion/react";
import { useBreakpoint } from "../../utils/utils";
import SEO from "../../common/SEO";
import {
  AddAdvertisementApi,
  GetAllAdvertisement,
  GetAllOffersByAdmin,
} from "../companyLogin/companyLoginApiHandler";
import dayjs from "dayjs";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Swal from "sweetalert2";
import { swalAlertPopProps } from "../../utils/commonUtils";
const LandingPage = () => {
  const slideNumber = {
    xs: 2,
    lg: 4,
    md: 3,
  };
  const userDetail = useSelector((state) => state.reducer.userDetail);

  const [salonCarousel, setSalonCarousel] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const navBarInputFields = useSelector(
  //   (state) => state.reducer.navBarInputFields
  // );
  // const dispatch = useDispatch();

  const offersCarousel = [
    {
      image: offerCarouselImage,
      text: "Offer valid till DD MM YYYY",
    },
    {
      image: offerCarouselImage,
      text: "Offer valid till DD MM YYYY",
    },
    {
      image: offerCarouselImage,
      text: "Offer valid till DD MM YYYY",
    },
    {
      image: offerCarouselImage,
      text: "Offer valid till DD MM YYYY",
    },
    {
      image: offerCarouselImage,
      text: "Offer valid till DD MM YYYY",
    },
    {
      image: offerCarouselImage,
      text: "Offer valid till DD MM YYYY",
    },
  ];

  const categoriesCarousel = [
    {
      image: categoryCard1,
      label: "Salon",
    },
    {
      image: categoryCard2,
      label: "Men’s Parlour",
    },
    {
      image: categoryCard3,
      label: "Beauty Parlour",
    },
    {
      image: categoryCard4,
      label: "Unisex Parlour",
    },
    {
      image: categoryCard5,
      label: "Massage Center",
    },
    {
      image: categoryCard6,
      label: "Wellness Center",
    },
    {
      image: categoryCard7,
      label: "Tatto Art Studio",
    },
    {
      image: categoryCard8,
      label: "Mehandi Artist",
    },
    {
      image: categoryCard9,
      label: "Skin Care Studio",
    },
    {
      image: categoryCard10,
      label: "Panchakarma",
    },
    {
      image: categoryCard11,
      label: "Makeup & Hairstyle Artist",
    },
    {
      image: categoryCard12,
      label: "Nail Art",
    },
  ];

  // const salonCarousel = [
  //   {
  //     image: salonImage,
  //     title: "Urban Salon",
  //     businessId: "B Id",
  //     type: "Unisex",
  //     location: "Pune",
  //     serviceAtHome: true,
  //     reviews: 5,
  //     ratings: 3.2,
  //   },
  //   {
  //     image: salonImage,
  //     title: "Urban Salon",
  //     businessId: "B Id",
  //     type: "Unisex",
  //     location: "Pune",
  //     serviceAtHome: true,
  //     reviews: 5,
  //     ratings: 3.2,
  //   },
  //   {
  //     image: salonImage,
  //     title: "Urban Salon",
  //     businessId: "B Id",
  //     type: "Unisex",
  //     location: "Pune",
  //     serviceAtHome: true,
  //     reviews: 5,
  //     ratings: 3.2,
  //   },
  //   {
  //     image: salonImage,
  //     title: "Urban Salon",
  //     businessId: "B Id",
  //     type: "Unisex",
  //     location: "Pune",
  //     serviceAtHome: true,
  //     reviews: 5,
  //     ratings: 3.2,
  //   },
  //   {
  //     image: salonImage,
  //     title: "Urban Salon",
  //     businessId: "B Id",
  //     type: "Unisex",
  //     location: "Pune",
  //     serviceAtHome: true,
  //     reviews: 5,
  //     ratings: 3.2,
  //   },
  //   {
  //     image: salonImage,
  //     title: "Urban Salon",
  //     businessId: "B Id",
  //     type: "Unisex",
  //     location: "Pune",
  //     serviceAtHome: true,
  //     reviews: 5,
  //     ratings: 3.2,
  //   },
  //   {
  //     image: salonImage,
  //     title: "Urban Salon",
  //     businessId: "B Id",
  //     type: "Unisex",
  //     location: "Pune",
  //     serviceAtHome: true,
  //     reviews: 5,
  //     ratings: 3.2,
  //   },
  //   {
  //     image: salonImage,
  //     title: "Urban Salon",
  //     businessId: "B Id",
  //     type: "Unisex",
  //     location: "Pune",
  //     serviceAtHome: true,
  //     reviews: 5,
  //     ratings: 3.2,
  //   },
  // ];

  const carouselRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [categoryActiveIndex, setCategoryActiveIndex] = useState(0);
  const [salonActiveIndex, setSalonActiveIndex] = useState(0);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const [isBeginningCat, setIsBeginningCat] = useState(true);
  const [isEndCat, setIsEndCat] = useState(false);
  const [data, setData] = useState([]);
  const [dataOffers, setDataOffers] = useState([]);
  const [rerender, setRerender] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setRerender(true);
    }, 100); // Delay can be 100-200ms

    return () => clearTimeout(timer);
  }, []);

  const handlePrev = () => {
    carouselRef.current.decrement();
  };

  const handleNext = () => {
    carouselRef.current.increment();
  };

  const offersPrevRef = useRef(null);
  const offersNextRef = useRef(null);
  const offersSwiperRef = useRef(null);

  const categoryPrevRef = useRef(null);
  const categoryNextRef = useRef(null);
  const categorySwiperRef = useRef(null);

  const salonPrevRef = useRef(null);
  const salonNextRef = useRef(null);
  const salonSwiperRef = useRef(null);

  const navBarInputFields = useSelector(
    (state) => state.reducer.navBarInputFields,
  );
  useEffect(() => {
    const payload = {
      area: navBarInputFields?.location || "Pune", // dynamic location like Services
      billerId: 0,
      search: "",
      search1: [],
      search2: [],
      search3: [],
    };

    getAllServices(payload, (data) => {
      //console.log("Top Rated Salons API Response:", data);

      const formatted = data.map((item) => ({
        ...item,
        image: item.imagePath || salonImage,
        title: item.enterpriseName,
        businessId: item.billerId,
        type: item.businessCategory,
        location: item.area,
        serviceAtHome: item.serviceFrom,
        serviceTo: item.serviceTo,
        reviews: item.totalReviews,
        ratings: item.averageRating,
      }));

      setSalonCarousel(formatted);
    });
  }, [navBarInputFields?.location]);
  useEffect(() => {
    if (
      offersSwiperRef.current &&
      offersPrevRef.current &&
      offersNextRef.current
    ) {
      offersSwiperRef.current.params.navigation.prevEl = offersPrevRef.current;
      offersSwiperRef.current.params.navigation.nextEl = offersNextRef.current;

      offersSwiperRef.current.navigation.destroy();
      offersSwiperRef.current.navigation.init();
      offersSwiperRef.current.navigation.update();
    }
  }, [offersPrevRef.current, offersNextRef.current]);

  useEffect(() => {
    const fetchAllOffers = async () => {
      try {
        let res = await GetAllAdvertisement();
        //console.log("Landing Page adver", res?.data.data.list);
        setData(res?.data.data.list);
      } catch (error) {
        console.error("Failed to fetch states:", error);
      }
    };
    // state: {
    //   selectedCategory: null;
    // }
    fetchAllOffers();
  }, []);
  useEffect(() => {
    const FetchAllOffersByAdmin = async () => {
      try {
        let res = await GetAllOffersByAdmin();
        //console.log("Landing Page Offer", res?.data.data.list);
        setDataOffers(res?.data.data.list);
        // //console.log()
      } catch (error) {
        console.error("Failed to fetch states:", error);
      }
    };

    FetchAllOffersByAdmin();
  }, []);
  const [expanded, setExpanded] = useState(false);
  const theme = useTheme();

  // Check if we are on mobile (xs/sm) or desktop (md and up)
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const allCategories = [
    {
      title: "Parlours & Stores",
      img: categoryCard1,
      path: routePath.SERVICESLIST,
    },
    { title: "Jobs", img: icon4, path: routePath.JOBS },
    {
      title: "Training Institutes",
      img: icon5,
      path: routePath.COURSES,
    },
    { title: "Franchises", img: icon2, path: routePath.FRANCHISE },
    {
      title: "White Label Companies",
      img: icon6,
      path: routePath.WHITELABLESLIST,
    },
    {
      title: "Consultants",
      img: icon1,
      path: routePath.CONSULTANTSLIST,
    },
    { title: "Wholesalers", img: icon7 },
    {
      title: "Furniture & Equipments",
      img: icon3,

      // path: routePath.FURNITURELIST,
    },
  ];

  // Logic: On mobile, show 4 or all based on state. On desktop, show all.
  const visibleCategories =
    isMobile && !expanded ? allCategories.slice(0, 4) : allCategories;

  const filtered = data.filter(
    (item) => item.status?.toLowerCase() === "active",
  );
const breakpoint = useBreakpoint(useTheme, useMediaQuery);
  return (
    <>
      <SEO
        title="Elegant Prime"
        description="All in One Basic Software for billing, inventory, and business management. Perfect solution for small and medium businesses."
        keywords="All-in-One Salon Management Software – POS, CRM & Billing, Salon & Spa Software – streamline operations, retain clients, boost revenue, Billing & Inventory Management Software for salons, Appointment Scheduling App for salons & spas,
Salon CRM Software India – customer retention made easy, Online Salon Booking System for clients, Loyalty Program Features to reward & retain customers, Staff Scheduling Software – manage beauticians & salon staff with ease,
Beauty Parlour Software with GST Billing – fast, compliant billing, Cloud-based Salon Management System – access anywhere, anytime
Salon Marketplace Integration – sell beauty products & services online, Best salon management app for parlours,
Best appointment scheduling app for salons, Affordable salon management software India, Mobile app for salon business growth,
Beauty parlour software India, Salon billing software with GST, Best salon management app, Salon staff scheduling software"
        canonical="https://elegantprime.in/"
        schema={{
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          name: "All in One Basic Software",
          applicationCategory: "BusinessApplication",
          operatingSystem: "Web, Windows, Mac",
        }}
      />

      <Box
        sx={{
          backgroundColor: "primary.main",
          color: "#fff",
          textAlign: "center",
          fontWeight: 600,
          py: "8px",
          fontSize: { xs: "12px", sm: "13px", md: "15px" },
          fontFamily: "'Montserrat', sans-serif",
          cursor: "pointer",
          textDecoration: "underline",
        }}
        onClick={() => {
          navigate(routePath.WHATISELEGANTPRIME);
        }}
      >
        What is Elegant Prime?
      </Box>

      <Box container>
        <Box
          sx={{
            px: { xs: 2, sm: 3, md: 3 },
            py: { xs: 2, sm: 2, md: 1 },

            mb: 2,
          }}
        >
          <Box
            sx={{
              border: "1px solid #88127F",
              borderRadius: "6px",
              position: "relative",
              px: { xs: 2, sm: 3 },
              py: { xs: 2, sm: 1 },
              transition: "height 0.3s ease-in-out",
            }}
          >
            {/* Heading */}
            {/* <Typography
              sx={{
                fontSize: { xs: "16px", sm: "20px", md: "25px" },
                color: "#01008B",
                fontWeight: 700,
                mb: 2,
                fontFamily: "Montserrat",
              }}
            >
              Search as you wish..
            </Typography> */}
            <Typography
              sx={{
                color: "#01008B",
                fontWeight: 700,
                fontFamily: "Montserrat",
                // Switch between "Border-Break" and "Normal Header"
                position: { xs: "absolute", md: "static" },
                top: { xs: "-14px" },
                left: { xs: "20px" },
                bgcolor: { xs: "white", md: "transparent" },
                px: { xs: 1, md: 0 },
                fontSize: { xs: "18px", md: "25px" },
                mb: { md: 2 },
              }}
            >
              Search as you wish..
            </Typography>
            {/* Categories Responsive Flex */}
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap", // ✅ Wrap for mobile
                gap: { xs: 2, sm: 3, md: 3, lg: 4 },
                justifyContent: { xs: "center", sm: "center" },
              }}
            >
              {/* Category Item */}
              {visibleCategories.map((cat, index) => (
                <Box
                  onClick={() => {
                    // if (cat.path === routePath.WHITELABLESLIST) {
                    //  const token = sessionStorage.getItem("smbToken");

                    //   if (!token) {
                    //     Swal.fire({
                    //       text: "Please login",
                    //       icon: "error",
                    //       ...swalAlertPopProps,
                    //     }).then((result) => {
                    //       navigate(routePath.CUSTOMERLOGIN); // redirect to login page
                    //     });

                    //     return; // ❗ stop navigation
                    //   }
                    // }
                    navigate(cat.path);
                  }}
                  key={index}
                  sx={{
                    width: {
                      xs: "20%",
                      sm: "22%",
                      md: "10%",
                    },

                    textAlign: "center",
                    cursor: "pointer",
                  }}
                >
                  {/* Image */}
                  <Box
                    component="img"
                    src={cat.img}
                    alt={cat.title}
                    sx={{
                      width: { xs: "55px", sm: "75px", md: "90px" },
                      height: { xs: "55px", sm: "75px", md: "90px" },
                      borderRadius: "9px",
                      mb: 1,
                    }}
                  />

                  {/* Text */}
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "10px",
                        sm: "13px",
                        md: "14px",
                        lg: "15px",
                      },
                      fontWeight: 600,
                      color: "#000",
                    }}
                  >
                    {cat.title}
                  </Typography>
                </Box>
              ))}
            </Box>
            {isMobile && (
              <Box
                sx={{
                  position: "absolute",
                  bottom: "-18px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  bgcolor: "white",
                  lineHeight: 0,
                }}
              >
                <IconButton
                  onClick={() => setExpanded(!expanded)}
                  sx={{
                    color: "#C51062",
                    border: "2px solid #C51062",
                    bgcolor: "white",
                    p: "2px",
                    "&:hover": { bgcolor: "white" },
                  }}
                >
                  {expanded ? (
                    <KeyboardArrowUpIcon />
                  ) : (
                    <KeyboardArrowDownIcon />
                  )}
                </IconButton>
              </Box>
            )}
          </Box>
        </Box>

        {/* herosection slider */}
        {data.length > 0 && (
          <Box pb={{ xs: 5, md: 0 }}>
            <Grid container alignItems={"center"}>
              <Grid
                item
                xs={12}
                sx={{
                  position: "relative",
                  height: { lg: "75vh", xs: "40vh", md: "53vh", sm: "40vh" },

                  width: "100%", //all brealpoints should be 100% in the width
                }}
              >
                <div
                  id="banner_carousel"
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <Carousel
                    ref={carouselRef}
                    autoPlay
                    key={data.length}
                    interval={3000}
                    infiniteLoop
                    autoFocus={true}
                    showThumbs={false}
                    showStatus={false}
                    showIndicators={filtered.length > 1}
                    showArrows={false}
                    swipeable
                    emulateTouch
                    stopOnHover={false}
                    dynamicHeight={false}
                    style={{ height: "100%" }}
                  >
                    {data.length > 0 &&
                      filtered.map((item, index) => (
                        <div key={index} style={{ height: "100%" }}>
                          <img
                            src={item.fileForWeb}
                            alt=""
                            style={{
                              // objectFit: "contain", // or give contain-fluid
                              height: "100%",
                              width: "100%",
                              display: "block",
                            }}
                          />
                        </div>
                      ))}
                  </Carousel>
                </div>
                {filtered.length > 1 && (
                  <>
                    <IconButton
                      onClick={handleNext}
                      sx={{
                        position: "absolute",
                        top: "50%",
                        right: "0",
                        textAlign: "center",
                        padding: "20px",
                        color: "primary.main",
                        transform: "translateY(-50%)",
                        "&:hover": { backgroundColor: "rgba(0,0,0,0.1)" },
                      }}
                    >
                      <ArrowForwardIosIcon />
                    </IconButton>
                    <IconButton
                      onClick={handlePrev}
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "0",
                        textAlign: "center",
                        padding: "20px",
                        color: "primary.main",
                        transform: "translateY(-50%)",
                        "&:hover": { backgroundColor: "rgba(0,0,0,0.1)" },
                      }}
                    >
                      <ArrowBackIosIcon />
                    </IconButton>
                  </>
                )}
              </Grid>
            </Grid>
          </Box>
        )}

        {/* Offers Carousel */}
        <Box pb={6}>
          <Grid container>
            <Grid item xs={12} sx={{ paddingX: "20px" }}>
              <Typography
                sx={{
                  fontSize: { xs: "16px", sm: "16px", md: "25px" },

                  fontWeight: 700,
                  paddingLeft: "20px",
                }}
              >
                Offers and Deals
              </Typography>

              {dataOffers.length > 0 && (
                <Box sx={{ width: "100%", position: "relative" }}>
                  <Button
                    ref={offersPrevRef}
                    sx={{
                      position: "absolute",
                      height: { xs: "40px", sm: "100%" },
                      top: { xs: "50%", sm: "0" },
                      transform: { xs: "translateY(-50%)", sm: "none" },

                      bottom: "0",
                      left: "0",
                      zIndex: 99,
                      width: "40px", // Reduced width
                      minWidth: "40px", // Ensure it doesn't expand
                      padding: "0", // Remove default padding
                      borderTopRightRadius: 0,
                      borderTopLeftRadius: "10px",
                      borderBottomLeftRadius: "10px",
                      backgroundColor: "#01008b85",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "primary.dark",
                      },
                      visibility: isBeginning ? "hidden" : "visible", // for Prev
                    }}
                  >
                    <ArrowBackIosNewIcon sx={{ fontSize: "16px" }} />{" "}
                    {/* Optional: Reduce icon size */}
                  </Button>

                  <Button
                    ref={offersNextRef}
                    sx={{
                      position: "absolute",
                      height: { xs: "40px", sm: "100%" },
                      top: { xs: "50%", sm: "0" },
                      transform: { xs: "translateY(-50%)", sm: "none" },

                      bottom: "0",
                      right: "0",
                      zIndex: 99,
                      borderTopLeftRadius: 0,
                      width: "40px", // Reduced width
                      minWidth: "40px", // Ensure it doesn't expand
                      padding: "0", // Remove default padding
                      borderTopRightRadius: "10px",
                      borderBottomRightRadius: "10px",
                      backgroundColor: "#01008b85",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "primary.dark",
                      },
                      visibility: isEnd ? "hidden" : "visible", // for Next
                    }}
                  >
                    <ArrowForwardIosIcon />
                  </Button>

                  <Swiper
                    modules={[Navigation]}
                    onSwiper={(swiper) => {
                      offersSwiperRef.current = swiper;

                      setTimeout(() => {
                        if (offersPrevRef.current && offersNextRef.current) {
                          swiper.params.navigation.prevEl =
                            offersPrevRef.current;
                          swiper.params.navigation.nextEl =
                            offersNextRef.current;

                          swiper.navigation.destroy();
                          swiper.navigation.init();
                          swiper.navigation.update();
                        }
                      });
                    }}
                    onSlideChange={(swiper) => {
                      setActiveIndex(swiper.activeIndex);
                      setIsBeginning(swiper.isBeginning);
                      setIsEnd(swiper.isEnd);
                    }}
                    spaceBetween={20}
                    slidesPerView={2}
                    breakpoints={{
                      1024: { slidesPerView: 4 },
                      768: { slidesPerView: 4 },
                      480: { slidesPerView: 2 },
                    }}
                  >
                    {dataOffers
                      .filter((item) => item.status?.toLowerCase() === "active")
                      .map((item, index) => (
                        <SwiperSlide key={index}>
                          <Card
                            sx={{
                              // padding: "4px",
                              boxShadow: "0px 4px 4px 0px #00000040",
                              height: {
                                xs: "180px",
                                sm: "150px",
                                md: "243px",
                              },
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                            }}
                          >
                            <CardContent
                              sx={{
                                padding: "4px",
                                // boxShadow: "0px 4px 4px 0px #00000040",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                              }}
                            >
                              <Box
                                component="img"
                                src={item.imagePath}
                                alt="offer"
                                sx={{
                                  width: "100%",
                                  height: "auto",
                                  maxHeight: {
                                    xs: "130px",
                                    md: "194px",
                                    sm: "none",
                                  },
                                  objectFit: "cover",
                                }}
                              />
                              <Typography
                                sx={{
                                  textAlign: "center",
                                  color: "primary.main",
                                  marginTop: "8px",
                                  fontSize: {
                                    xs: "12px",
                                    sm: "13px",
                                    md: "15px",
                                  },
                                }}
                              >
                                Offer valid till{" "}
                                {dayjs(item.toDate).format("DD MM YYYY")}
                                {/* {item.offerInformation} */}
                              </Typography>
                            </CardContent>
                          </Card>
                        </SwiperSlide>
                      ))}
                  </Swiper>
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>

        {/* Categories Carousel */}
        <Box pb={5}>
          <Grid container>
            <Grid item xs={12} sx={{ paddingX: "20px" }}>
              <Typography
                sx={{
                  fontSize: { xs: "16px", sm: "16px", md: "25px" },

                  fontWeight: 700,
                  paddingLeft: "20px",
                }}
              >
                Categories
              </Typography>
              <Box sx={{ width: "100%", position: "relative" }}>
                <Button
                  ref={categoryPrevRef}
                  sx={{
                    position: "absolute",
                    height: { xs: "40px", sm: "100%" },
                    top: { xs: "50%", sm: "0" },
                    transform: { xs: "translateY(-50%)", sm: "none" },

                    bottom: "0",
                    left: "0",
                    zIndex: 99,
                    borderTopRightRadius: 0,
                    width: "40px", // Reduced width
                    minWidth: "40px", // Ensure it doesn't expand
                    padding: "0", // Remove default padding
                    borderTopLeftRadius: "10px",
                    borderBottomLeftRadius: "10px",
                    backgroundColor: "#01008b85",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "primary.dark",
                    },
                    visibility: isBeginningCat ? "hidden" : "visible", // for Prev
                  }}
                >
                  <ArrowBackIosNewIcon />
                </Button>
                <Button
                  ref={categoryNextRef}
                  sx={{
                    position: "absolute",
                    height: { xs: "40px", sm: "100%" },
                    top: { xs: "50%", sm: "0" },
                    transform: { xs: "translateY(-50%)", sm: "none" },

                    bottom: "0",
                    right: "0",
                    zIndex: 99,
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: "10px",
                    borderBottomRightRadius: "10px",
                    width: "40px", // Reduced width
                    minWidth: "40px", // Ensure it doesn't expand
                    padding: "0", // Remove default padding
                    backgroundColor: "#01008b85",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "primary.dark",
                    },
                    visibility: isEndCat ? "hidden" : "visible", // for Next
                  }}
                >
                  <ArrowForwardIosIcon />
                </Button>
                <Swiper
                  modules={[Navigation, Autoplay]}
                  spaceBetween={20}
                  slidesPerView={
                    slideNumber[useBreakpoint(useTheme, useMediaQuery)] ?? 4
                  }
                  loop={false}
                  onSwiper={(swiper) => {
                    categorySwiperRef.current = swiper;
                    swiper.params.navigation.prevEl = categoryPrevRef.current;
                    swiper.params.navigation.nextEl = categoryNextRef.current;
                    swiper.navigation.init();
                    swiper.navigation.update();
                  }}
                  onSlideChange={(swiper) => {
                    setCategoryActiveIndex(swiper.activeIndex);
                    setIsBeginningCat(swiper.isBeginning);
                    setIsEndCat(swiper.isEnd);
                  }}
                  breakpoints={{
                    1024: { slidesPerView: 3 },
                    768: { slidesPerView: 3 },
                    480: { slidesPerView: 2 },
                  }}
                >
                  {categoriesCarousel?.map((item, index) => (
                    <SwiperSlide key={index}>
                      <Card
                        onClick={() =>
                          navigate(routePath.SERVICESLIST, {
                            state: {
                              selectedCategory: item.label,
                              ts: Date.now(), //when we pass this goes time with this, then add it into dependicy array for update
                            },
                          })
                        }
                        sx={{
                          padding: 0,
                          boxShadow: "0px 4px 14.7px 5px #00000040",
                          borderRadius: "8px",
                          height: {
                            xs: "140px",
                            sm: "220px",
                            md: "auto",
                          },
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          cursor: "pointer",
                          "@media (max-width:375px)": {
                            height: "140px", // a bit taller only for very small phones
                          },

                          "@media (min-width:376px) and  (max-width:427px)": {
                            height: "160px", // a bit taller only for very small phones
                          },
                        }}
                      >
                        <CardContent sx={{ padding: "0px !important" }}>
                          <Box
                            component="img"
                            src={item?.image}
                            alt="image"
                            sx={{
                              width: "100%",
                              height: "auto",
                              maxHeight: {
                                xs: "130px",
                                md: "none",
                                sm: "none",
                              },
                              objectFit: "contain", // optional
                            }}
                          />
                          <Typography
                            sx={{
                              textAlign: "center",
                              color: "primary.main",
                              py: "5px",
                              fontWeight: 600,
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              whiteSpace: "normal", // required for multiline
                              maxHeight: "3.2em",
                            }}
                          >
                            {item?.label}
                          </Typography>
                        </CardContent>
                      </Card>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* Salons Carousel */}
        <Box pb={6}>
          <Grid container>
            <Grid item xs={12} sx={{ paddingX: "20px" }}>
              <Typography
                sx={{
                  fontSize: { xs: "15px", sm: "15px", md: "25px" },
                  fontWeight: 700,
                  paddingLeft: "20px",
                }}
              >
                Top Rated Salons
              </Typography>
              {salonCarousel.length > 0 && (
                <Box sx={{ width: "100%", position: "relative" }}>
                  <Button
                    ref={salonPrevRef}
                    sx={{
                      position: "absolute",
                      top: "0",
                      bottom: "0",
                      height: { xs: "40px", sm: "100%" },
                      top: { xs: "50%", sm: "0" },
                      transform: { xs: "translateY(-50%)", sm: "none" },

                      left: "0",
                      zIndex: 99,
                      borderTopRightRadius: 0,
                      borderTopLeftRadius: "10px",
                      borderBottomLeftRadius: "10px",
                      width: "40px", // Reduced width
                      minWidth: "40px", // Ensure it doesn't expand
                      padding: "0", // Remove default padding
                      backgroundColor: "#01008b85",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "primary.dark",
                      },
                      visibility: salonActiveIndex === 0 ? "hidden" : "visible",
                    }}
                  >
                    <ArrowBackIosNewIcon />
                  </Button>
                  <Button
                    ref={salonNextRef}
                    sx={{
                      position: "absolute",
                      top: "0",
                      bottom: "0",
                      right: "0",
                      zIndex: 99,
                      height: { xs: "40px", sm: "100%" },
                      top: { xs: "50%", sm: "0" },
                      transform: { xs: "translateY(-50%)", sm: "none" },

                      borderTopLeftRadius: 0,
                      borderTopRightRadius: "10px",
                      borderBottomRightRadius: "10px",
                      width: "40px", // Reduced width
                      minWidth: "40px", // Ensure it doesn't expand
                      padding: "0", // Remove default padding
                      backgroundColor: "#01008b85",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "primary.dark",
                      },
                      visibility:
                        salonActiveIndex === salonCarousel.length - 5
                          ? "hidden"
                          : "visible",
                    }}
                  >
                    <ArrowForwardIosIcon />
                  </Button>
                  <Swiper
                    modules={[Navigation, Autoplay]}
                    spaceBetween={10}
                    // slidesPerView={
                    //   slideNumber[useBreakpoint(useTheme, useMediaQuery)] ?? 4
                    // }
                    slidesPerView={slideNumber[breakpoint] ?? 4}
                    loop={false}
                    onSwiper={(swiper) => {
                      salonSwiperRef.current = swiper;
                      swiper.params.navigation.prevEl = salonPrevRef.current;
                      swiper.params.navigation.nextEl = salonNextRef.current;
                      swiper.navigation.init();
                      swiper.navigation.update();
                    }}
                    onSlideChange={(swiper) => {
                      setSalonActiveIndex(swiper.activeIndex);
                    }}
                    breakpoints={{
                      1440: { slidesPerView: 4 },
                      1024: { slidesPerView: 3 },
                      768: { slidesPerView: 3 },
                      425: { slidesPerView: 1 },
                      375: { slidesPerView: 1 },
                      320: { slidesPerView: 1 },
                    }}
                  >
                    {salonCarousel?.map((item, index) => {
                      let stars = [];
                      for (let i = 1; i <= 5; i++) {
                        if (i <= item?.ratings) {
                          stars.push(
                            <StarIcon
                              key={i}
                              sx={{ color: "#ff5e00", fontSize: "18px" }}
                            />,
                          );
                        } else {
                          stars.push(
                            <StarOutlineIcon
                              key={i}
                              sx={{ color: "#ff5e00", fontSize: "18px" }}
                            />,
                          );
                        }
                      }
                      return (
                        <SwiperSlide key={index}>
                          <Card
                            sx={{
                              padding: "10px",
                              boxShadow: "0px 4px 14.7px 5px #00000040",
                              borderRadius: "8px",
                            }}
                            onClick={() => {
                              // //console.log("Clicked item:", {
                              //   imagePath: item.image || salonImage,
                              //   enterpriseName: item.title,
                              //   billerId: item.businessId,
                              //   businessCategory: item.type,
                              //   area: item.location,
                              //   serviceFrom: item.serviceAtHome,
                              //   serviceTo: item.serviceTo,
                              //   totalReviews: item.reviews,
                              //   averageRating: item.ratings,
                              // });
                              dispatch(
                                setDetail({
                                  ...item,
                                  imagePath: item.image || salonImage,
                                  enterpriseName: item.title,
                                  billerId: item.businessId,
                                  businessCategory: item.type,
                                  area: item.location,
                                  serviceFrom: item.serviceAtHome,
                                  serviceTo: item.serviceTo,
                                  totalReviews: item.reviews,
                                  averageRating: item.ratings,
                                }),
                              );
                              navigate(routePath.SALON);
                            }}
                          >
                            <CardContent sx={{ padding: "0px !important" }}>
                              <img
                                src={item?.image}
                                alt="image"
                                style={{ width: "100%" }}
                              />
                              <Box sx={{ paddingY: "10px" }}>
                                <Typography
                                  sx={{
                                    textAlign: "left",
                                    color: "#000",
                                    fontWeight: 600,
                                    fontSize: "17px",
                                    lineHeight: "1.4em", // line height
                                    height: `calc(1.4em * 2)`, // reserve height for 2 lines
                                    display: "-webkit-box",
                                    WebkitLineClamp: 2, // clamp at 2 lines
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {item?.title}
                                  <Typography
                                    component="span"
                                    sx={{
                                      fontSize: "12px",
                                      marginLeft: "4px",
                                      fontWeight: 500,
                                    }}
                                  >
                                    (Business Id - {item?.businessId})
                                  </Typography>
                                </Typography>
                                <Typography
                                  sx={{
                                    textAlign: "left",
                                    color: "#000",
                                    fontWeight: 500,
                                    fontSize: "13px",
                                    // lineHeight: "1.4em", // line height
                                    // height: `calc(1.4em * 2)`, // reserve height for 2 lines
                                    display: "-webkit-box",
                                    WebkitLineClamp: 1, // clamp at 2 lines
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {item?.type}
                                </Typography>
                                <Typography
                                  sx={{
                                    textAlign: "left",
                                    color: "#000",
                                    fontWeight: 500,
                                    fontSize: "13px",
                                  }}
                                >
                                  {item?.serviceTo} {"  "}
                                  <b>Service At -</b>
                                  {item?.serviceAtHome || ""}
                                </Typography>
                                <Typography
                                  sx={{
                                    textAlign: "left",
                                    color: "#000",
                                    fontWeight: 500,
                                    fontSize: "13px",
                                  }}
                                ></Typography>
                                <Typography
                                  sx={{
                                    textAlign: "left",
                                    color: "#000",
                                    fontWeight: 500,
                                    fontSize: "13px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <img
                                    src={locationIcon}
                                    alt="icon"
                                    style={{
                                      width: "15px",
                                      marginRight: "4px",
                                    }}
                                  />
                                  {item?.location}
                                </Typography>
                                <Typography
                                  sx={{
                                    textAlign: "left",
                                    color: "#000",
                                    fontWeight: 500,
                                    fontSize: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {stars.map((star) => star)}
                                  <Typography
                                    component="span"
                                    sx={{ fontSize: "13px" }}
                                  >
                                    {item?.ratings} ({item?.reviews} Reviews)
                                  </Typography>
                                </Typography>
                              </Box>
                            </CardContent>
                          </Card>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>

        <Footer />
      </Box>
    </>
  );
};

export default LandingPage;
